var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEventDetails(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7 20c.3 0 .3.4 0 .5l-1.6.5c-4 1.3-6 .2-7.3-3.8l-1.3-4c-1.3-3.9-.2-6 3.8-7.3l.5-.1c.4-.2.8.2.7.6l-.2.7-1 4.2c-1 4.7.5 7.3 5.2 8.4l1.2.3Z",
    fill: "gray"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m17.2 3.2-1.7-.4C12.2 2 10.2 2.7 9 5.1c-.3.6-.5 1.4-.7 2.2l-1 4.2c-1 4.2.3 6.2 4.5 7.2l1.6.4 1.7.3c3 .3 4.7-1.2 5.6-4.8l1-4.2c1-4.1-.3-6.2-4.5-7.2Zm-2 10.1c0 .4-.3.6-.6.6h-.2l-3-.8a.7.7 0 0 1 .4-1.4l3 .7c.4.1.6.5.5 1Zm3-3.3c0 .3-.4.5-.7.5h-.2l-4.8-1.2a.7.7 0 0 1 .3-1.5L17.7 9c.4.1.6.5.5 1Z",
    fill: "gray"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventDetails);
export default __webpack_public_path__ + "static/media/eventDetails.a8415af51a4dd2b93fa0b3c82fd3ccc4.svg";
export { ForwardRef as ReactComponent };